import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id DD0191F8-8AE0-4D80-A29C-AB7451DAE464
 * name battery-alert-variant
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-alert-variant.svg
 * tags
 * - Battery 
 * - Alert / Error 
 */
export const BatteryAlertVariantIcon = createSvgIcon(<><path d="M14.67 4H13V2H7V4H5.33C4.6 4 4 4.6 4 5.33V20.67C4 21.4 4.6 22 5.33 22H14.67C15.4 22 16 21.4 16 20.67V5.33C16 4.6 15.4 4 14.67 4M21 13H19V7H21V13M21 17H19V15H21V17Z" /></>, 'BatteryAlertVariantIcon');
export default BatteryAlertVariantIcon